<template>
  <div>
    <el-dialog append-to-body :close-on-click-modal="false" title="会员交易记录" :visible.sync="dialogFormVisible" width="80%" v-dialogDrag>
      <el-tabs disabled type="border-card" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="充值" name="充值">
          <rec ref="rec"></rec>
        </el-tab-pane>
        <el-tab-pane label="历史充值" name="历史充值">
          <recs ref="recs"></recs>
        </el-tab-pane>
        <el-tab-pane label="疗程" name="疗程">
          <pro ref="pro"></pro>
        </el-tab-pane>
        <el-tab-pane label="历史疗程" name="历史疗程">
          <pros ref="pros"></pros>
        </el-tab-pane>
        <el-tab-pane label="交易记录" name="交易记录">
          <cash ref="cash"></cash>
        </el-tab-pane>
      </el-tabs>
      <member ref="member" @memberData="memberData"></member>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { partten } from "../../../partten/index";
import member from "@/components/member/index";
import rec from "./components/rec.vue";
import recs from "./components/recs.vue";
import pro from "./components/pro.vue";
import pros from "./components/pros.vue";
import cash from "./components/cash.vue";
import { storeMemberOne } from "@/api/eashier";
export default {
  props:{
    mobilePhone:{
      type:String,
      default:''
    }
  },
  components: {
    rec,
    recs,
    pro,
    pros,
    cash,
    member,
  },
  data() {
    return {
      dialogFormVisible:false,
      form: {
        month: new Date(),
      },
      activeName: "充值", //标签页默认标签
    };
  },
  watch:{
    dialogFormVisible:{
      handler(show){
        if(show){
          let mobilePhone = this.mobilePhone
          this.form.mobilePhone = mobilePhone
          storeMemberOne({
          mobilePhone: this.form.mobilePhone,
          storeId: sessionStorage.getItem("parentId"),
          }).then((res) => {
            if (res.data != undefined && res.data.state == 0) {
            this.$message.error({
              message: "账户已锁定, 不允许使用 ! ",
            });
            this.$alert("账户已锁定, 不允许使用 !", "提示", {
              confirmButtonText: "确定",
              confirmButtonClass: "confirmbtnFalses",
              type: "warning",
              center: true,
              callback: (action) => {},
            });
            } else {
            if (res.code == "000000" || res.code == "200004") {
              if (res.code == "000000") {
                  this.form = res.data;
                if (this.activeName == "充值") {
                  this.$refs.rec.show(this.form);
                }
                if (this.activeName == "疗程") {
                  this.$refs.pro.show(this.form);
                }
                if (this.activeName == "交易记录") {
                  this.$refs.cash.show(this.form);
                }
              } else {
                if (res.code == "200004") {
                  this.$confirm(res.message + ",请先注册!", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    cancelButtonClass: "cancelbtnFalses",
                    confirmButtonClass: "confirmbtnFalses",
                    type: "warning",
                  }).then(() => {});
                } else {
                  this.$alert(res.message, "提示", {
                    confirmButtonText: "确定",
                    confirmButtonClass: "confirmbtnFalses",
                    type: "warning",
                    center: true,
                    callback: (action) => {},
                  });
                }
              }
            } else {
              this.$alert("查询会员信息 : " + res.message, "提示", {
                confirmButtonText: "确定",
                confirmButtonClass: "confirmbtnFalses",
                type: "warning",
                center: true,
                callback: (action) => {},
              });
            }
            }
          });
        }
      },
      immediate:true
    }
  },
  methods: {
    //时间改变方法
    change(date) {
      // this.form.month = ''
      console.log(date)
      this.$refs.cash.show(this.form);
    },
    //标签页改变
    //切换标签页
    handleClick(tab, event) {
      if (this.form.memberName) {
        if (tab.name == "充值") {
          this.$refs.rec.show(this.form);
        }
        if (tab.name == "疗程") {
          this.$refs.pro.show(this.form);
        }
        if (tab.name == "历史充值") {
          this.$refs.recs.show(this.form);
        }
        if (tab.name == "历史疗程") {
          this.$refs.pros.show(this.form);
        }
        if (tab.name == "交易记录") {
          this.$refs.cash.show(this.form);
        }
        this.activeName = tab.name;
      } else {
        this.$message.error({ message: "请先选择会员!" });
      }
    },
    //打开选择会员弹窗
    openMember() {
      this.$refs.member.show(this.vip);
    },
    //选中会员返回方法
    memberData(v) {
      this.form.mobilePhone = v.mobilePhone;
      this.query();
    },
    //输入手机号是查询
    //查询方法
    query() {
      var number = partten.phoneNum;
      if (!number.test(this.form.mobilePhone*1)) {
        this.$message.info({
          message: "请输入正确的手机号 ! ",
        });
      } else {
        storeMemberOne({
          mobilePhone: this.form.mobilePhone,
          storeId: sessionStorage.getItem("parentId"),
        }).then((res) => {
          if (res.data != undefined && res.data.state == 0) {
            this.$message.error({
              message: "账户已锁定, 不允许使用 ! ",
            });
            this.$alert("账户已锁定, 不允许使用 !", "提示", {
              confirmButtonText: "确定",
              confirmButtonClass: "confirmbtnFalses",
              type: "warning",
              center: true,
              callback: (action) => {},
            });
          } else {
            if (res.code == "000000" || res.code == "200004") {
              if (res.code == "000000") {
                this.form = res.data;
                if (this.activeName == "充值") {
                  this.$refs.rec.show(this.form);
                }
                if (this.activeName == "疗程") {
                  this.$refs.pro.show(this.form);
                }
                if (this.activeName == "交易记录") {
                  this.$refs.cashAchi.show(this.form);
                }
              } else {
                if (res.code == "200004") {
                  this.$confirm(res.message + ",请先注册!", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    cancelButtonClass: "cancelbtnFalses",
                    confirmButtonClass: "confirmbtnFalses",
                    type: "warning",
                  }).then(() => {});
                } else {
                  this.$alert(res.message, "提示", {
                    confirmButtonText: "确定",
                    confirmButtonClass: "confirmbtnFalses",
                    type: "warning",
                    center: true,
                    callback: (action) => {},
                  });
                }
              }
            } else {
              this.$alert("查询会员信息 : " + res.message, "提示", {
                confirmButtonText: "确定",
                confirmButtonClass: "confirmbtnFalses",
                type: "warning",
                center: true,
                callback: (action) => {},
              });
            }
          }
        });
      }
    },
  },
  created() {},
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/trading/index.vue